import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import { ControlledInput } from 'components/Inputs/ControlledInput';
import { Button } from 'components/Core/Button';
import SelectComponent from 'components/Inputs/SelectComponent';
import { ISelectStyleProps } from 'components/Inputs/SelectComponent/types';
import { isDuplicatedOptions, statusOptions } from './constants';
import { brandsCataloguesFiltersFormTranslations } from './translations';
import { IBrandsCataloguesFiltersFormFields, BrandsCataloguesFiltersFormTransFields } from './types';
import styles from './pointsLogsFiltersForm.module.scss';

const selectStyles: ISelectStyleProps = {
  containerStyles: {
    marginBottom: 0,
    width: 200,
    backgroundColor: 'white',
    borderRadius: 32,
  },
  controlStyles: {
    background: 'white',
    borderRadius: 32,
  },
};

export const BrandsCataloguesFiltersForm: FC = observer(() => {
  const {
    brandsStore: { brandCataloguesFilters, updateBrandCataloguesFilters },
  } = useStore();

  const { t } = useMyTranslations<BrandsCataloguesFiltersFormTransFields>([
    brandsCataloguesFiltersFormTranslations.name,
  ]);

  const useFormMethods = useForm<IBrandsCataloguesFiltersFormFields>({ defaultValues: brandCataloguesFilters });

  const { handleSubmit } = useFormMethods;

  const onSubmit = async (inputData: IBrandsCataloguesFiltersFormFields) => {
    updateBrandCataloguesFilters(inputData);
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FormProvider {...(useFormMethods as any)}>
      <div className={styles.filters}>
        <SelectComponent
          name='status'
          placeholder={t('status')}
          options={statusOptions.map((item) => ({
            id: item,
            name: t(item),
          }))}
          optionLabel='name'
          optionValue='id'
          styleProps={selectStyles}
        />
        <SelectComponent
          name='dublicatedStatus'
          placeholder={t('dublicatedStatus')}
          options={isDuplicatedOptions.map((item) => ({
            id: item,
            name: t(item),
          }))}
          optionLabel='name'
          optionValue='id'
          styleProps={selectStyles}
        />
        <ControlledInput
          name='search'
          type='text'
          placeholder={t('search')}
          isRemoveMargin
          classNameProp={styles.searchInput}
        />
        <Button
          title={t('search')}
          onClick={handleSubmit(onSubmit)}
          classNameProp={`${styles.btn} ${styles.searchBtn}`}
        />
      </div>
    </FormProvider>
  );
});
